import React from "react";
import { TemplatesStyled } from "./styled";
import { Button } from "antd";
import TemplatesStore from "../../../stores/templatesStore";
import { observer, inject } from "mobx-react";
import { observable, action } from "mobx";
import TemplatesPageTitle from "./PageTitle/PageTitle";
import { TemplateModel } from "../../../stores/TemplateModel";
import { notification } from "antd";
import Template from "../Template/Template";
import TitleTemplatesGroup from "./TitleTemplatesGroup/TitleTemplatesGroup";
import { withRouter } from "react-router-dom";

interface TemplatesProps {
  templatesStore?: TemplatesStore;
}
const YourTemplate = inject('userStore')(withRouter(observer(({ history,userStore }: any) => {
  console.log('userStore.needToUpgrade',userStore.needToUpgrade);
  return (
    <>
      Your Template &nbsp;&nbsp;
      {!userStore.needToUpgrade  ? <Button
        type="primary"
        size="small"
        onClick={() => history.push(`templates/new`)}
      >
        Add new +
      </Button> : <Button size="small" type="primary" target="parent" href="/wp-admin/admin.php?page=wpmailer-pricing">Upgrade > </Button>}
    </>
  );
})));

@observer
class Templates extends React.PureComponent<TemplatesProps, any> {
  whyDidYouRender = true;

  @observable templateForModal: TemplateModel | null = null;

  constructor(props: TemplatesProps) {
    super(props);

    this.props.templatesStore?.setCurrentPageNumber(1);
  }

  @action setTemplateForModal = (template: TemplateModel | null = null) => {
    this.templateForModal = template;
  };

  componentDidMount() {
    this.props.templatesStore?.getTemplates({});
  }

  componentWillUnmount = () => {
    this.props.templatesStore?.setCurrentPageNumber(-1);
  };

  onDelete = async (template: TemplateModel) => {
    const { templatesStore } = this.props;

    try {
      await template.delete();
      await templatesStore?.getTemplates({ page: 1 });
      //router.navigate("templates", { page: 1 });

      notification["success"]({
        message: `Delete template ${template.name.toUpperCase()} successful`,
        description: ""
      });
    } catch (err) {}
  };

  onPageSettingsChange = async (
    page: number,
    pageSize?: number | undefined
  ) => {
    await this.props.templatesStore?.getTemplates({ page, pageSize });
    //router.navigate("templates", { page, pageSize });
  };

  renderModalFooter = () => {
    return (
      <>
        <Button type="link" onClick={this.goEditPage}>
          Edit
        </Button>
        <Button type="primary" onClick={this.closeModal}>
          Close
        </Button>
      </>
    );
  };

  goEditPage = () => {
    //this.props.router.navigate("template", { id: this.templateForModal?.id })
  };

  closeModal = () => this.setTemplateForModal();

  render() {
    return (
      <>
        <TemplatesPageTitle
          showAddButton={this.props.templatesStore?.currentPageNumber !== 1}
        />
        <TitleTemplatesGroup
          title="Our Example Templates"
          subTitle="By reallygoodemails.com"
        />
        <TemplatesStyled>
          {this.props.templatesStore?.exampleTemplates.map((template: any,index:number) => {
            return <Template key={index} template={template} />;
          })}
        </TemplatesStyled>
        <TitleTemplatesGroup
          title={<YourTemplate />}
          subTitle=""
          style={{
            borderTop: "1px solid #dadada",
            paddingTop: 16,
            marginTop: 30
          }}
        />
        <TemplatesStyled>
          {this.props.templatesStore?.templates.map((template: any,index:number) => {
            return <Template key={index} template={template} />;
          })}
        </TemplatesStyled>
      </>
    );
  }
}
export default observer(Templates);
